export const INCREMENT_ENROLLMENT_CURRENT_SEARCH_STEP_INDEX =
  "INCREMENT_ENROLLMENT_CURRENT_SEARCH_STEP_INDEX";
export const DECREMENT_ENROLLMENT_CURRENT_SEARCH_STEP_INDEX =
  "DECREMENT_ENROLLMENT_CURRENT_SEARCH_STEP_INDEX";
export const INCREMENT_ENROLLMENT_CURRENT_STEP_INDEX =
  "INCREMENT_ENROLLMENT_CURRENT_STEP_INDEX";
export const DECREMENT_ENROLLMENT_CURRENT_STEP_INDEX =
  "DECREMENT_ENROLLMENT_CURRENT_STEP_INDEX";
export const SET_EDIT_FLAG = "SET_EDIT_FLAG";
export const SET_BASIC_EDIT_FLAG = "SET_BASIC_EDIT_FLAG";
export const SET_GUID = "SET_GUID";
export const SET_GUID_ERROR = "SET_GUID_ERROR";
export const SET_REQUIRES_USER_AUTH = "SET_REQUIRES_USER_AUTH";
export const SET_SEARCHED_PROVIDERS = "SET_SEARCHED_PROVIDERS";
export const SET_FORM_ERRORS = "SET_FORM_ERRORS";
export const SET_SELECTED_PROVIDER = "SET_SELECTED_PROVIDER";
export const SET_ACTIVE_FORMS = "SET_ACTIVE_FORMS";
export const SET_FORM_VALUES = "SET_FORM_VALUES";
export const SET_UNEDITED_FORM_VALUES = "SET_UNEDITED_FORM_VALUES";
export const RESET_ERRORS = "RESET_ERRORS";
export const SET_REQUEST_STATUS = "SET_REQUEST_STATUS";
export const SET_PAGE_NUMBER = "SET_PAGE_NUMBER";
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export const SET_TERMS_AND_CONDITIONS_STATUS =
  "SET_TERMS_AND_CONDITIONS_STATUS";
export const SET_TERMS_AND_CONDITIONS_ERROR = "SET_TERMS_AND_CONDITIONS_ERROR";
export const SET_FEATURE_FLAGS = "SET_FEATURE_FLAGS";
export const SET_FILE_METHOD_ERROR = "SET_FILE_METHOD_ERROR";
export const SET_FILE_METHOD_USER_ID = "SET_FILE_METHOD_USER_ID";
export const SET_PREVIOUS_ADDRESS_CHECKBOX =
  "SET_PREVIOUS_MAILING_ADDRESS_CHECKBOX";
export const SET_PHYSICAL_MAILING_ADDRESS_CHECKBOX =
  "SET_PHYSICAL_MAILING_ADDRESS_CHECKBOX";
export const SET_UNEDITED_PHYSICAL_MAILING_ADDRESS_CHECKBOX =
  "SET_UNEDITED_PHYSICAL_MAILING_ADDRESS_CHECKBOX";
export const SET_UNEDITED_PREVIOUS_ADDRESS_CHECKBOX =
  "SET_UNEDITED_PREVIOUS_ADDRESS_CHECKBOX";
export const SET_SHOW_FRP_ADDITIONAL_INFORMATION =
  "SET_SHOW_FRP_ADDITIONAL_INFORMATION";
export const ADD_RECOMENDED_ADDR = "ADD_RECOMENDED_ADDR";
export const SET_ACCOUNT_NUMBER_REGEX = "SET_ACCOUNT_NUMBER_REGEX";
export const SET_STATEMENT_IMG = "SET_STATEMENT_IMG";
export const SET_SUBMISSION_COMPLETE = "SET_SUBMISSION_COMPLETE";
export const RESET_CURRENT_SEARCH_STEP_INDEX =
  "RESET_CURRENT_SEARCH_STEP_INDEX";
export const RESET_CURRENT_STEP_INDEX = "RESET_CURRENT_STEP_INDEX";
export const SET_SESSION_MODAL = "SET_SESSION_MODAL";
export const SET_SEARCH_VIEW = "SET_SEARCH_VIEW";
export const RESET_FORMS = "RESET_FORMS";
export const SET_TIMEOUT_FLAG = "SET_TIMEOUT_FLAG";
export const SET_EXISTING_HSF_ACCOUNT = "SET_EXISTING_HSF_ACCOUNT";
export const SAVE_EXISTING_HSF_ACCOUNT = "SAVE_EXISTING_HSF_ACCOUNT";
export const SET_EMAIL_VERIFICATION_STATUS = "SET_EMAIL_VERIFICATION_STATUS";
export const SET_CONSENT_TO_CONTACT = "SET_CONSENT_TO_CONTACT";
export const SET_SELF_ENROLLMENT_APP_ID = "SET_SELF_ENROLLMENT_APP_ID";
export const SET_SHOW_FEEDBACK_MODAL = "SET_SHOW_FEEDBACK_MODAL";
export const SET_FEEDBACK_DETAILS = "SET_FEEDBACK_DETAILS";
export const SET_ENROLLMENT_SOURCE = "SET_ENROLLMENT_SOURCE";
export const SET_BILLING_STATEMENT_IMAGE = "SET_BILLING_STATEMENT_IMAGE";
